<!-- 页脚 -->

<template>
    <div class="content_footer">
      <ul class="nav linkNav">
        <li class="useful_link"><a @click="showAboutTruthso">关于真相搜索</a>&nbsp;&nbsp;&nbsp;&nbsp;</li>
        <li class="useful_link" @click="userAgree">用户协议</li>
        <li class="useful_link">&nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/feedback/">问题反馈</router-link></li>
      </ul>
      <ul class="nav">
        <li class="company_info">Copyright@2013 - {{ yearTime }} All rights reserved&nbsp;&nbsp;-&nbsp;&nbsp;</li>
        <li class="company_info">版权所有：真相网络科技（北京）有限公司</li>
      </ul>
      <ul class="nav">
        <li class="company_info"><a href="https://beian.miit.gov.cn/" style="color: rgb(151, 151, 151);" target="_blank">京ICP备16033891号-1</a>&nbsp;&nbsp;-&nbsp;&nbsp;</li>
        <li class="company_info">公京检第1792001号&nbsp;&nbsp;-&nbsp;&nbsp;</li>
        <li class="company_info">公安部安全与警用电子产品质量检测中心&nbsp;&nbsp;-&nbsp;&nbsp;</li>
        <li class="company_info">国家安全防范报警系统产品质量监督检验中心（北京）</li>
      </ul>
    </div>
</template>

<style scoped>
  .content_footer {
    overflow: hidden;
    height: 50px;
    background-color: rgb(58, 58, 60);
    color: rgb(151, 151, 151);
    box-sizing: border-box;
    padding-top: 5px;
    position: relative;
  }

  .content_footer .nav {
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    text-align: left;
    box-sizing: border-box;
    padding-left: 20px;
  }

  .content_footer .nav li,
  .content_footer .nav li a{
    /*padding: 0 0.4rem;*/
    text-decoration: none;
  }

  .content_footer .nav li{
    /*border-right: 1px solid white;*/
  }
  .content_footer .nav .company_info{
  }

  .content_footer .nav .useful_link{
    cursor: pointer;
  }
  .content_footer .nav .useful_link a{
    color: rgb(151, 151, 151);
  }
  .content_footer .linkNav{
    position:absolute;
    right: 40px;
    top:8px;
    font-size: 14px;
  }
</style>

<script>

  export default {
    name: 'contentFooter',
    data () {
      return {
        yearTime:new Date().getFullYear()
      }
    },
    methods: {
      userAgree () {
        this.$store.commit('showUserAgree',true);
      },
      showAboutTruthso () {
        this.$store.commit('showAboutTruthso', true);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// contentFooter.vue?8880aa3c